import { useEffect, useState, useRef } from 'react';

import {
  CATEGORIES,
  MY_TOPICS,
  OTHER_TOPICS,
  SUGGESTED_TOPICS,
  SUPER_CATEGORIES,
} from '../constants/types';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';
import handleFetchCategory from '../utils/handleFetchCategory';

const getTotal = (totalAllTopics, isEnabledToPublishSuperCategories) => {
  const total = [];

  if (totalAllTopics[MY_TOPICS]) {
    total.push(totalAllTopics[MY_TOPICS].totalTopics);
  }

  if (totalAllTopics[SUGGESTED_TOPICS]) {
    total.push(totalAllTopics[SUGGESTED_TOPICS].totalTopics);
  }

  if (isEnabledToPublishSuperCategories) {
    if (totalAllTopics[SUPER_CATEGORIES]) {
      Object.values(
        totalAllTopics[SUPER_CATEGORIES].totalSuperCategories || {},
      ).forEach((superCategory) => {
        total.push(superCategory.totalTopics);
      });
    }
  } else {
    if (totalAllTopics[OTHER_TOPICS]) {
      total.push(totalAllTopics[OTHER_TOPICS].totalTopics);
    }

    Object.values(totalAllTopics[CATEGORIES] || {}).forEach((category) => {
      total.push(category.totalTopics);
    });
  }

  const items = total.filter((item) => item !== undefined);

  if (items.length > 0) {
    let totalTopics = 0;

    items.forEach((item) => {
      totalTopics += item;
    });

    return totalTopics;
  }

  return undefined;
};

const getIsFetching = (totalAllTopics, isEnabledToPublishSuperCategories) => {
  const isFetching = [];

  if (totalAllTopics[MY_TOPICS]) {
    isFetching.push(totalAllTopics[MY_TOPICS].isFetchingTopics);
  }

  if (totalAllTopics[SUGGESTED_TOPICS]) {
    isFetching.push(totalAllTopics[SUGGESTED_TOPICS].isFetchingTopics);
  }

  if (isEnabledToPublishSuperCategories) {
    if (totalAllTopics[SUPER_CATEGORIES]) {
      isFetching.push(totalAllTopics[SUPER_CATEGORIES].isFetchingTopics);
    }
  } else {
    if (totalAllTopics[OTHER_TOPICS]) {
      isFetching.push(totalAllTopics[OTHER_TOPICS].isFetchingTopics);
    }

    Object.values(totalAllTopics[CATEGORIES] || {}).forEach((category) => {
      isFetching.push(category.isFetchingTopics);
    });
  }

  const items = isFetching.filter((item) => item === false || item === true);

  if (items.length > 0) {
    let isFetchingTopics = false;

    items.forEach((item) => {
      isFetchingTopics = isFetchingTopics || item;
    });

    return isFetchingTopics;
  }

  return undefined;
};

const useTopicsLists = () => {
  const {
    isEnabledToPublishSuperCategories,
    selectedCategoryId,
    setCurrentView,
    setSelectedCategory,
    setSelectedSuperCategory,
    setUserAuthorizationInfo,
    totalAllTopics,
  } = useTopicsIndexContext();

  const [dataTotalTopics, setDataTotalTopics] = useState({});
  const [isFetchingCategory, setIsFetchingCategory] = useState(false);
  const cancelTokenRefCategory = useRef(null);

  useEffect(() => {
    const total = getTotal(totalAllTopics, isEnabledToPublishSuperCategories);
    const isFetching = getIsFetching(
      totalAllTopics,
      isEnabledToPublishSuperCategories,
    );

    setDataTotalTopics({ totalTopics: total, isFetchingTopics: isFetching });
  }, [totalAllTopics]);

  // Fetch category each time a category is selected.
  // Needed when user is going directly on a Category page.
  useEffect(() => {
    if (selectedCategoryId) {
      handleFetchCategory({
        cancelTokenRef: cancelTokenRefCategory,
        id: selectedCategoryId,
        isFetching: isFetchingCategory,
        setCurrentView,
        setIsFetching: setIsFetchingCategory,
        setSelectedCategory,
        setSelectedSuperCategory,
        setUserAuthorizationInfo,
        withCategorySet: isEnabledToPublishSuperCategories,
      });
    }
  }, [selectedCategoryId]);

  return {
    dataTotalTopics,
  };
};

export default useTopicsLists;
